<template>
  <nav class="flex items-center justify-between px-2 py-3 mb-3">
    <div class="container flex flex-wrap items-center justify-between mx-auto">
      <div class="w-full flex justify-between lg:w-auto lg:static">
        <!-- Company name -->
        <router-link
          to="/"
          class="text-2xl font-extrabold whitespace-nowrap uppercase text-pink-800 cursor-pointer mr-4 py-2"
        >
          Flavours
        </router-link>
        <!-- Hamburger menu -->
        <button
          class="cursor-pointer text-xl border border-solid rounded block lg:hidden px-3 py-1"
          type="button"
          @click="toggle"
        >
          <fa icon="bars"></fa>
        </button>
      </div>
      <!-- Navbar Content -->
      <div :class="{ hidden: !showMenu, flex: showMenu }" class="lg:flex lg:flex-grow items-center">
        <ul class="flex flex-col lg:flex-row list-none ml-auto">
          <li class="nav-item" v-for="(item, index) in navItems" :key="index">
            <router-link
              :to="item.path"
              class="cursor-pointer flex items-center text-md uppercase font-bold text-gray-800 hover:opacity-75 px-3 py-2"
            >
              <span class="ml-2">{{ item.label }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <a
              class="cursor-pointer flex items-center text-xl hover:opacity-50 md:px-3 px-5 pb-2 pt-2.5 text-blue-500"
              href="https://www.facebook.com/FlavoursBroodjes"
            >
              <fa :icon="['fab', 'facebook']"></fa>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Navbar-component',
  setup() {
    const showMenu = ref(false);

    function toggle() {
      showMenu.value = !showMenu.value;
    }

    const navItems = [
      { path: '/', label: 'Welkom' },
      { path: '/Photos', label: "Foto's" },
      { path: '/Menu', label: 'Menu' },
      { path: '/Services', label: 'Services' },
    ];

    return { showMenu, toggle, navItems };
  },
});
</script>
